import { render, staticRenderFns } from "./TheInventoryDrawer.vue?vue&type=template&id=3e1baf07&"
import script from "./TheInventoryDrawer.vue?vue&type=script&lang=ts&"
export * from "./TheInventoryDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports